var exports = {
  "q": "badge__Gkxv1c",
  "n": "link__d7Iroi",
};

module.exports = exports;
